import React from 'react';
import { Col, Row, Text, Input, SelectPicker } from 'rsuite';
import { ItemDataType } from 'rsuite/esm/MultiCascadeTree';
import {
  ALL_PERMITS_STATUS_OPTIONS_ENUM,
  PERMIT_SORT_OPTIONS_ENUM,
} from '../../common/enums';

export interface PermitFiltersProps {
  ownerLabel: string;
  registrationTypeVerbiage: string;
  registrationVerbiage: string;
  searchFilter: string;
  setSearchFilter: (value: string) => void;
  setSortFilter: (value: PERMIT_SORT_OPTIONS_ENUM) => void;
  setStatusFilter: (value: ALL_PERMITS_STATUS_OPTIONS_ENUM) => void;
  sortFilter: PERMIT_SORT_OPTIONS_ENUM;
  sortOptions: ItemDataType<PERMIT_SORT_OPTIONS_ENUM>[];
  statusFilter: ALL_PERMITS_STATUS_OPTIONS_ENUM;
  statusOptions: ItemDataType<ALL_PERMITS_STATUS_OPTIONS_ENUM>[];
}

const PermitFilters: React.FC<PermitFiltersProps> = ({
  ownerLabel,
  registrationTypeVerbiage,
  registrationVerbiage,
  searchFilter,
  setSearchFilter,
  setSortFilter,
  setStatusFilter,
  sortFilter,
  sortOptions,
  statusFilter,
  statusOptions,
}) => (
  <Row className="mb-20">
    <Col
      xs={24}
      md={12}
      className="sm-pb-10"
    >
      <Text className="mb-4 text-small">
        Search for a {registrationVerbiage}
      </Text>
      <Input
        className="ellipsis-placeholder"
        placeholder={`Search by address, ${registrationTypeVerbiage.toLowerCase()} number, ${ownerLabel} name...`}
        value={searchFilter}
        onChange={(value) => setSearchFilter(value)}
      />
    </Col>
    <Col
      xs={24}
      md={6}
      className="sm-pb-10"
    >
      <Text className="mb-4 text-small">Status</Text>
      <SelectPicker
        labelKey="name"
        valueKey="value"
        data={statusOptions}
        searchable={false}
        value={statusFilter}
        onSelect={(value) => setStatusFilter(value)}
        style={{ width: '100%' }}
        menuStyle={{ width: 'auto', minWidth: '200px' }}
        cleanable={false}
        className="filter-picker"
      />
    </Col>
    <Col
      xs={24}
      md={6}
      className="sm-pb-10"
    >
      <Text className="mb-4 text-small">Sort by</Text>
      <SelectPicker
        labelKey="name"
        valueKey="value"
        data={sortOptions}
        searchable={false}
        value={sortFilter}
        onSelect={(value) => setSortFilter(value)}
        style={{ width: '100%' }}
        menuStyle={{ width: 'auto', minWidth: '200px' }}
        cleanable={false}
        className="filter-picker"
      />
    </Col>
  </Row>
);

export default PermitFilters;
